module.exports = __webpack_public_path__ + "img/custom-code-tag.4aa3614d.svg";